import React from 'react';
import PropTypes from 'prop-types';
import styles from './QuizProgressBarV4.css';

function QuizProgressBarV4({ currentSlideIndex, totalSlides }) {
    const progress = currentSlideIndex ? (currentSlideIndex / totalSlides) * 100 : 0;

    return (
        <div className={styles.root}>
            <div className={styles.fill} style={{ width: `${progress}%` }} />
        </div>
    );
}

QuizProgressBarV4.propTypes = {
    currentSlideIndex: PropTypes.number,
    totalSlides: PropTypes.number
};

export {
    QuizProgressBarV4
};
